<template>
  <div class="main-navigation">
    <v-navigation-drawer ref="vNavigationDrawerNavMain" v-model="navigationDrawerOpen" :clipped="clipped"
      :mobile-break-point="mobileBreakpointMax + 1" class="mari-drawer mari" fixed dark app>
      <h1 class="mari-nav-logo">
        <router-link :to="{ name: 'Startseite' }" v-html="projectTitleLogo"></router-link>
      </h1>
      <v-list>
        <v-list-tile v-for="(route, i) in displayRoutes" :key="i" value="true"
          v-bind="{ to: getBasePath(route.path), href: getBasePath(route.path) }" :class="route.listItemCssClass">
          <v-list-tile-content>
            <v-list-tile-title v-text="route.label[lang]"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list>
        <v-list-tile v-for="(page, i) in pageNav" :key="i" value="true"
          v-bind="{ to: '/page/' + page.slug, href: '/page/' + page.slug }" :class="'navitem_pid_' + page.parent">
          <v-list-tile-content>
            <v-list-tile-title v-text="page.menu_title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list>
        <v-list-tile v-on:click.native="changeLang">
          <v-list-tile-content>
            <v-list-tile-title v-html="langSwitch" class="lang-switch"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <img src="/static/img/mari-nav-icon-white.svg" :alt="projectTitle" class="toolbar-logo-closed">
    </v-navigation-drawer>
    <v-toolbar v-if="showToolbar" class="main-toolbar" color="mari-toolbar mari" fixed dense flat scroll-off-screen dark
      app>
      <v-toolbar-side-icon @click.stop="navigationDrawerOpen = !navigationDrawerOpen"></v-toolbar-side-icon>
      <h1 class="toolbar-mari-nav-logo" v-html="projectTitleLogo"></h1>
      <v-spacer></v-spacer>
    </v-toolbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      mobileBreakpointMax: 1024,
      projectTitle: 'Mosse Art research Initiative',
      projectTitleLogo: 'Mosse<br>Art Research<br>Initiative',
      showToolbar: true,
      navigationDrawerOpen: true,
      clipped: false,
      routes: this.$router.options.routes
    }
  },
  beforeMount () {
    this.checkDrawerOpen()
    this.checkToolbarShow()
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.checkResized)
    })
  },
  methods: {
    checkDrawerOpen () {
      if (window.innerWidth <= this.mobileBreakpointMax) {
        this.navigationDrawerOpen = false
      }
    },
    checkToolbarShow () {
      if (window.innerWidth > this.mobileBreakpointMax) {
        this.showToolbar = false
      } else {
        this.showToolbar = true
      }
    },
    checkResized () {
      this.checkToolbarShow()
      // console.log(this.$vuetify.application.left)
    },
    changeLang () {
      if (this.lang === 'de') {
        this.$store.commit('setLang', 'en')
        this.$store.commit('switchPagesLang', 'en')
      } else {
        this.$store.commit('setLang', 'de')
        this.$store.commit('switchPagesLang', 'de')
      }
      if (this.$router.history.current.name === 'Seite') {
        this.$router.push({ name: 'Startseite' })
      } else if (this.$router.history.current.name === 'Post' ||
        this.$router.history.current.name === 'Posts') {
        this.$router.push({ name: 'Startseite' })
      }
    },
    getBasePath (path) {
      // remove string that starts with : (e.g. :id?)
      return path.replace(/\/:[^/]+/, '/')
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkResized)
  },
  computed: {
    ...mapGetters([
      'pageNav',
      'lang'
    ]),
    langSwitch () {
      if (this.lang === 'de') {
        return '<span>DE</span> | <span class="lang-inactive">EN</span>'
      } else {
        return '<span class="lang-inactive">DE</span> | <span>EN</span>'
      }
    },
    displayRoutes () {
      return this.routes.filter(route => { return route.label && route.displayNav }).sort((a, b) => a.position - b.position)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/Main.vue